import ManualInsertQuestion from "pages/dashboard/shared/ManualInsertQuestion"

const AdminInsertQuestions = () => {
  return <ManualInsertQuestion/>;
};

export default AdminInsertQuestions;
